import { render, staticRenderFns } from "./DeployedTable.vue?vue&type=template&id=07fcbbb2&scoped=true&"
import script from "./DeployedTable.vue?vue&type=script&lang=js&"
export * from "./DeployedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fcbbb2",
  null
  
)

export default component.exports